import type { HelpFile } from '../../types/help'
import { TestResultsPanelTestIds } from '../../../testids/TestResultsPanelTestIds'

export const testResultsPanelHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [TestResultsPanelTestIds.testResultsPanel]: 'Outcome of evaluating the restriction rule against the test population, including which identities matched and which violate the rule.',
    [TestResultsPanelTestIds.cardTitleTestResults]: 'Summary card showing how many identities matched, how many violate the rule, and how many were evaluated.',
    [TestResultsPanelTestIds.affectedIdentitiesDialog]: 'Dialog listing identities affected by the rule with their party and violation indicator.',
    [TestResultsPanelTestIds.btnViewAffected]: 'Open the list of identities affected by this rule.',
    [TestResultsPanelTestIds.colName]: 'Display name of the affected identity.',
    [TestResultsPanelTestIds.colParty]: 'Party (person, organization, or agent) the affected identity belongs to.',
    [TestResultsPanelTestIds.colViolationIndicator]: 'Whether this identity violates the restriction rule.',
    [TestResultsPanelTestIds.testResultsEmpty]: 'No identities matched the rule scope — adjust the scope and try again.',
    [TestResultsPanelTestIds.testResultsError]: 'Test run failed; review the rule definition and retry.',
    [TestResultsPanelTestIds.testResultsEvaluated]: 'Total number of identities the rule was evaluated against.',
    [TestResultsPanelTestIds.testResultsLoading]: 'Indicates the test run is in progress.',
    [TestResultsPanelTestIds.testResultsMatched]: 'Total number of identities the rule scope matched.',
    [TestResultsPanelTestIds.testResultsViolations]: 'Total number of identities currently violating this rule.',
  },
}
